import { RbacSubjects } from '../../rbac/constants'
import { RbacRoleName } from './constants/assignable-roles'

// Roles whose permissions are LOCKED and cannot be edited — mirrors the EPS
// server-side guards in rbac-permissions.service: PROTECTED_ROLE_REQUIRED_PERMISSIONS
// ('Platform Admin', 'RBAC Admin') and PERMISSION_LOCKED_ROLE_NAMES
// ('US-Restricted Data Access'). Editing any of them would 422 on save, so the
// UI disables the permission editor and flags these roles as locked. Keep in
// sync with the server.
export const LOCKED_ROLE_NAMES = new Set<string>([
  RbacRoleName.PLATFORM_ADMIN,
  RbacRoleName.RBAC_ADMIN,
  RbacRoleName.US_RESTRICTED_DATA_ACCESS,
])

export function isLockedRole(roleName?: string): boolean {
  return roleName ? LOCKED_ROLE_NAMES.has(roleName) : false
}

/** True for a single-purpose role whose fixed grant is its only permission. */
export function isFixedPurposeRole(roleName?: string): boolean {
  return roleName === RbacRoleName.US_RESTRICTED_DATA_ACCESS
}

// Subjects only the listed roles may hold — mirrors EPS ROLE_EXCLUSIVE_SUBJECTS.
// Saving one on any other role would 422, so the editor does not offer it
// there. HR Admin and Finance Manager hold UsRestrictedData because they manage
// their own company and its employees (EMS-11021).
const ROLE_EXCLUSIVE_SUBJECTS: ReadonlyMap<
  string,
  ReadonlySet<string>
> = new Map([
  [
    RbacSubjects.UsRestrictedData,
    new Set<string>([
      RbacRoleName.US_RESTRICTED_DATA_ACCESS,
      RbacRoleName.HR_ADMIN,
      RbacRoleName.FINANCE_MANAGER,
    ]),
  ],
])

export function isSubjectGrantableToRole(
  subjectId: string,
  roleName?: string
): boolean {
  const allowedRoles = ROLE_EXCLUSIVE_SUBJECTS.get(subjectId)
  return (
    allowedRoles === undefined ||
    (roleName !== undefined && allowedRoles.has(roleName))
  )
}
